import type { MongoAbility } from "@casl/ability";
import { createMongoAbility } from "@casl/ability";
import { useMemo } from "react";
import { useAppSelector } from "store/store";

export const useAbility = (): MongoAbility => {
    const permissions = useAppSelector((state) => state.settings.userData?.permissions);

    return useMemo(() => createMongoAbility(permissions || []), [permissions]);
};
